module.exports = __webpack_public_path__ + "img/hrob03.8fd7ff86.png";